import React, { Component, PropTypes } from 'react';
import { RaisedButton } from 'material-ui';
import R from 'ramda';

class MouseOverEditDiv extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showButtons: false,
    };
  }

  _showActionButtons = () => {
    if (this.props.editable) this.setState({ showButtons: true });
  };

  _hideActionButtons = () => {
    if (this.props.editable) this.setState({ showButtons: false });
  };

  render() {
    const style = Object.assign({}, { alignItems: 'center', height: '16px', marginRight: '4px' }, this.props.style);
    if (this.props.singleLineTitle || this.props.doubleLineTitle) {
      style.width = '110px';
      style.float = 'right';
      if (this.props.singleLineTitle) style.marginTop = '0';
    }
    const onEdit = R.path(['props', 'actionButtons', 'props', 'onEdit'], this);
    return (
      <div
        className={this.props.className}
        onMouseOver={() => this._showActionButtons()}
        onMouseLeave={() => this._hideActionButtons()}
        style={{
          position: 'relative',
          paddingTop: this.props.editable && this.props.extendPadding ? '14px' : '0px',
        }}
      >
        {
          /*
          <div style={style} className="mouse-over-edit">{this.state.showButtons ? this.props.actionButtons : undefined}</div>
          */
        }
        {this.props.children}
        <div
          style={{
            display: this.state.showButtons ? 'block' : 'none',
            position: 'absolute',
            color: 'white',
            top: 0,
            left: 0,
            height: this.props.exposeBottomButtons ? 'calc(100% - 48px)' : '100%',
            width: '100%',
            zIndex: 1,
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            overflowX: 'hidden',
            transition: '0.5s',
            paddingTop: 'auto',
            cursor: 'pointer',
            textAlign: this.props.hintOnRight ? 'right' : 'center',
          }}
          onClick={onEdit}
        >
          <div style={style} className="mouse-over-edit">{this.props.actionButtons}</div>
        </div>
      </div>
    );
  }
}

MouseOverEditDiv.propTypes = {
  editable: PropTypes.bool,
  actionButtons: PropTypes.node,
  children: PropTypes.node,
  singleLineTitle: PropTypes.bool,
  doubleLineTitle: PropTypes.bool,
  regularDiv: PropTypes.bool,
  style: PropTypes.object,
  hintOnRight: PropTypes.bool,
  extendPadding: PropTypes.bool,
};

export default MouseOverEditDiv;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/mouse-over-edit-div.jsx